import { format } from "date-fns";
import { sendWarningReport } from "utils/reporting";

export function getFlightIdentifiers({
  flightDate,
  airlineCode,
  flightNumber,
  arrivalAirportIata,
  departureAirportIata,
}: {
  flightDate: Date | null;
  flightNumber: string | null;
  airlineCode: string | undefined;
  arrivalAirportIata: string | undefined;
  departureAirportIata: string | undefined;
}) {
  if (
    [airlineCode, flightNumber, departureAirportIata, arrivalAirportIata, flightDate].some(
      (value) => !value,
    ) ||
    !flightDate
  ) {
    sendWarningReport(
      `Cant create flight identifier, missing data",
      airlineCode: ${airlineCode},
      flightNumber: ${flightNumber},
      departureAirportIata: ${departureAirportIata},
      departureAirportIata: ${departureAirportIata},
      flightDate: ${flightDate},
    `,
    );
    return null;
  }

  return [
    airlineCode,
    flightNumber,
    format(flightDate, "yyyyMMdd"),
    departureAirportIata,
    arrivalAirportIata,
  ].join("-");
}
